import { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { getReceivables } from "../../services/orgService";
import { errorToast } from "../Toasts/Toasts";

// Who owes us what, longest owed first.
//
// Straight from Zoho Books - it is the only place that knows whether an
// invoice was paid, and a figure worked out here would be a second opinion
// about money. A customer with a portal account can be chased through it; one
// without is a Books customer we have no other line to.

const inr = (n) => `₹${Number(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;
const ageClass = (d) => (d > 90 ? "text-danger fw-semibold" : d > 30 ? "text-warning" : "text-muted");

const Receivables = () => {
  const [d, setD] = useState(null);
  const load = useCallback(async () => {
    try { setD(await getReceivables()); } catch (e) { errorToast("Could not load receivables"); }
  }, []);
  useEffect(() => { load(); }, [load]);

  if (!d) return null;

  return (
    <div className="page-body px-0 py-lg-2 py-1 mt-0 mt-lg-3 ms-3">
      <div className="container-fluid p-0">
        <div className="row-title px-2">
          <h6 className="fw-bold mb-0">Pending collection</h6>
          <div className="small text-muted">
            {d.connected
              ? `${inr(d.total)} outstanding across ${d.rows.length} customers · from Zoho Books`
              : "Zoho Books is not connected yet, so there is nothing to show."}
          </div>
        </div>

        {d.connected && (
          <div className="card mt-2"><div className="card-body p-0">
            <div className="table-responsive table-scroll"><table className="table table-sm mb-0 align-middle">
              <thead><tr><th>Customer</th><th className="text-end">Outstanding</th><th className="text-end">Invoices</th><th className="text-end">Oldest</th><th>Portal</th></tr></thead>
              <tbody>
                {d.rows.map((r) => (
                  <tr key={r.customerId} className={r.oldestDays > 90 ? "table-warning" : ""}>
                    <td>
                      {r.organizationId
                        ? <Link to={`/organizations/${r.organizationId}`}>{r.customer}</Link>
                        : r.customer}
                    </td>
                    <td className="text-end fw-semibold">{inr(r.outstanding)}</td>
                    <td className="text-end">{r.invoices}</td>
                    <td className={`text-end ${ageClass(r.oldestDays)}`}>{r.oldestDays ? `${r.oldestDays} d` : "not due"}</td>
                    <td className="small">{r.onPortal ? <span className="badge bg-success">on portal</span> : <span className="text-muted">not invited</span>}</td>
                  </tr>
                ))}
                {!d.rows.length && <tr><td colSpan={5} className="text-muted p-3">Nothing outstanding.</td></tr>}
              </tbody>
            </table></div>
          </div></div>
        )}
      </div>
    </div>
  );
};

export default Receivables;
